module.exports = __webpack_public_path__ + "static/img/Love-Eggs-nav-tile-900x1200.39fc887.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/fenlei/Love-Eggs-nav-tile-900x1200.jpg
// module id = JsOE
// module chunks = 0